import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  COOKIE_SETTINGS_EVENT,
  getCookieConsent,
  initCookieConsent,
  setCookieConsent,
  type CookieConsentChoice,
} from '../lib/cookieConsent';
import { isReactSnap } from '../lib/runtime';

const CookieConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isReactSnap()) return;
    initCookieConsent();
    if (!getCookieConsent()) {
      setVisible(true);
    }

    const onOpenSettings = () => setVisible(true);
    window.addEventListener(COOKIE_SETTINGS_EVENT, onOpenSettings);
    return () => {
      window.removeEventListener(COOKIE_SETTINGS_EVENT, onOpenSettings);
    };
  }, []);

  const choose = (choice: CookieConsentChoice) => {
    setCookieConsent(choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className='fixed bottom-4 left-4 z-40 w-[min(100%-2rem,24rem)] pointer-events-none'
      role='dialog'
      aria-labelledby='cookie-consent-title'
      aria-describedby='cookie-consent-desc'
    >
      <div className='pointer-events-auto rounded-2xl border border-slate-200 bg-white shadow-xl p-5'>
        <h2
          id='cookie-consent-title'
          className='font-header text-base font-semibold text-slate-900 mb-1.5'
        >
          Cookies
        </h2>
        <p
          id='cookie-consent-desc'
          className='font-sans text-sm text-slate-600 leading-relaxed mb-4'
        >
          Optional analytics help us improve the site. Necessary cookies keep
          you signed in.{' '}
          <Link
            to='/privacy'
            className='text-primary-600 hover:text-primary-700 underline'
          >
            Privacy
          </Link>
        </p>
        <button
          type='button'
          onClick={() => choose('accepted')}
          className='w-full inline-flex items-center justify-center rounded-xl bg-primary-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-700 hover:shadow-md transition-all'
        >
          OK, got it
        </button>
        <button
          type='button'
          onClick={() => choose('rejected')}
          className='w-full mt-2 py-1 text-sm font-medium text-slate-400 hover:text-slate-600 transition-colors'
        >
          No thanks
        </button>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
